export const menuData = [
  {
    path: '/LargeDataScreen',
    title: '数据大屏',
    icon: require('@/assets/images/saving.png'),
    iconActive: require('@/assets/images/saving-active.png'),
    meta: {
      title: '数据大屏',
      requiredPermissions: ['data_large_screen_menu'],
      showInSidebar: false
    },
    submenu: [
      {
        path: '/LargeDataScreen/EnergyUseDataNew',
        title: '工厂用能大屏',
        meta: {
          title: '工厂用能大屏',
          requiredPermissions: ['energy_data_large_screen_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/LargeDataScreen/IncomeEnergyLeLi',
        title: '雷利收益大屏',
        meta: {
          title: '雷利收益大屏',
          requiredPermissions: ['leili_earn_data_large_screen_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/LargeDataScreen/IncomeData',
        title: '子公司收益大屏',
        meta: {
          title: '子公司收益大屏',
          requiredPermissions: ['earn_data_large_screen_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/LargeDataScreen/carbonEmission',
        title: '碳排放看板',
        meta: {
          title: '碳排放看板',
          requiredPermissions: ['carbon_emission_dashboard_menu'],
          showInSidebar: false
        }
      },
      
      // {
      //   path: '/LargeDataScreen/EnergyUseData',
      //   title: '用能数据大屏',
      //   meta: {
      //     title: '用能数据大屏',
      //     requiredPermissions: ['energy_data_large_screen_menu'],
      //     showInSidebar: false
      //   }
      // },
      
    ]
  },
  {
    path: '/RealTimeMonitoring',
    title: '实时监测',
    icon: require('@/assets/images/overview.png'),
    iconActive: require('@/assets/images/overview-active.png'),
    meta: {
      title: '实时监测',
      requiredPermissions: ['real_time_monitor_menu'],
      showInSidebar: false
    },
    submenu: false
  },
  {
    path: '/ReportAnalysis',
    title: '数据分析',
    icon: require('@/assets/images/baobiao.png'),
    iconActive: require('@/assets/images/baobiao-active.png'),
    meta: {
      title: '数据分析',
      requiredPermissions: ['roport_menu'],
      showInSidebar: false
    },
    submenu: [
      {
        path: '/ReportAnalysis/EnergyTrend',
        title: '能耗趋势',
        meta: {
          title: '能耗趋势',
          requiredPermissions: ['energy_trend_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/ReportAnalysis/compareEnergy',
        title: '工况对比',
        meta: {
          title: '工况对比',
          requiredPermissions: ['energy_compare_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/ReportAnalysis/compareAnalysis',
        title: '对比分析',
        meta: {
          title: '对比分析',
          requiredPermissions: ['compare_analysis_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/ReportAnalysis/EnergySavingDetails',
        title: '电机日收益明细',
        meta: {
          title: '电机日收益明细',
          requiredPermissions: ['earn_detail_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/ReportAnalysis/EnergyUseingDetails',
        title: '客户电机日用能',
        meta: {
          title: '客户电机日用能',
          requiredPermissions: ['energy_detail_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/ReportAnalysis/RealTimeDetails',
        title: '电机原始数据',
        meta: {
          title: '电机原始数据',
          requiredPermissions: ['device_real_data_menu'],
          showInSidebar: false
        }
      },

      
      
    ]
  },
  {
    path: '/ReportCenter',
    title: '收益结算',
    icon: require('@/assets/images/shouyi.png'),
    iconActive: require('@/assets/images/shouyi-active.png'),
    meta: {
      title: '收益结算',
      requiredPermissions: ['revenue settlement_menu'],
      showInSidebar: false
    },
    submenu: [
      {
        path: '/ReportCenter/profitStatement',
        title: '收益报表',
        meta: {
          title: '收益报表',
          requiredPermissions: ['org_earn_report_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/ReportCenter/incomeStatement',
        title: '用能报表',
        meta: {
          title: '用能报表',
          requiredPermissions: ['earn_report_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/ReportCenter/SettlementStatement',
        title: '客户结算汇总',
        meta: {
          title: '客户结算汇总',
          requiredPermissions: ['settle_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/ReportCenter/collectionReport',
        title: '回款报表',
        meta: {
          title: '回款报表',
          requiredPermissions: ['earn_receive_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/ReportCenter/revenueRanking',
        title: '客户排名',
        meta: {
          title: '客户排名',
          requiredPermissions: ['earn_rank_menu'],
          showInSidebar: false
        }
      },
    ]
  },
  {
    path: '/alarmManagement',
    title: '告警管理',
    icon: require('@/assets/images/gaojing.png'),
    iconActive: require('@/assets/images/gaojing-active.png'),
    meta: {
      title: '告警管理',
      requiredPermissions: ['alarm_manage_menu'],
      showInSidebar: false
    },
    submenu: [
      {
        path: '/alarmManagement/alarmMessage',
        title: '告警信息',
        meta: {
          title: '告警信息',
          requiredPermissions: ['alarm_info_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/alarmManagement/alarmRule',
        title: '告警规则',
        meta: {
          title: '告警规则',
          requiredPermissions: ['alarm_config_menu'],
          showInSidebar: false
        }
      },
     
    ]
  },
  {
    path: '/MotorAssets',
    title: '电机管理',
    icon: require('@/assets/images/dianjiZC.png'),
    iconActive: require('@/assets/images/dianjiZC-active.png'),
    meta: {
      title: '电机管理',
      requiredPermissions: ['asset_manage_menu'],
      showInSidebar: false
    },
    submenu: [
      {
        path: '/MotorAssets/MotorAssets',
        title: '电机资产',
        meta: {
          title: '电机资产',
          requiredPermissions: ['device_asset_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/MotorAssets/CustomerProfile',
        title: '客户档案',
        meta: {
          title: '客户档案',
          requiredPermissions: ['customer_menu'],
          showInSidebar: false
        }
      },
      
      {
        path: '/MotorAssets/ItemList',
        title: '项目清单',
        meta: {
          title: '项目清单',
          requiredPermissions: ['project_menu'],
          showInSidebar: false
        }
      }
    ]
  },
  {
    path: '/EnergyCarbon',
    title: '能碳管理',
    icon: require('@/assets/images/nentan.png'),
    iconActive: require('@/assets/images/nentan-active.png'),
    meta: {
      title: '能碳管理',
      requiredPermissions: ['energy_carbon__manage_menu'],
      showInSidebar: false
    },
    submenu: [
      {
        path: '/EnergyCarbon/CarbonSo',
        title: '碳排放因子',
        meta: {
          title: '碳排放因子',
          requiredPermissions: ['carbon_emission_ratio_config_menu'],
          showInSidebar: false
        }
      },
     
    ]
  },
  {
    path: '/basic',
    title: '基础配置',
    icon: require('@/assets/images/basic.png'),
    iconActive: require('@/assets/images/basic-active.png'),
    meta: {
      title: '基础配置',
      requiredPermissions: ['base_setting_menu'],
      showInSidebar: false
    },
    submenu: [
      // {
      //   path: "/basic/LabelConfiguration",
      //   title: "标签配置",
      //   meta: {
      //     title: "标签配置",
      //     requiredPermissions: ["label_menu"],
      //     showInSidebar: false,
      //   },
      // },
      {
        path: '/basic/motor',
        title: '型号档案',
        meta: {
          title: '型号档案',
          requiredPermissions: ['motor_type_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/MotorAssets/baseEnergySet',
        title: '基准能耗配置',
        meta: {
          title: '基准能耗配置',
          requiredPermissions: ['base_energy_config_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/MotorAssets/ElectricityPriceAllocation',
        title: '电价配置',
        meta: {
          title: '电价配置',
          requiredPermissions: ['priceSetting_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/MotorAssets/AllocationSharingRules',
        title: '分成规则配置',
        meta: {
          title: '分成规则配置',
          requiredPermissions: ['earn_rule_menu'],
          showInSidebar: false
        }
      },
    ]
  },
  {
    path: '/platform',
    title: '平台管理',
    icon: require('@/assets/images/plateform.png'),
    iconActive: require('@/assets/images/plateform-active.png'),
    authority: 'TENANT_ADMIN',
    meta: {
      title: '平台管理',
      requiredPermissions: ['platform_manage_menu'],
      showInSidebar: false
    },
    submenu: [
      {
        path: '/platform/organization',
        title: '组织管理',
        meta: {
          title: '组织管理',
          requiredPermissions: ['org_manage_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/platform/UserManagement',
        title: '用户管理',
        meta: {
          title: '用户管理',
          requiredPermissions: ['user_manage_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/platform/RoleManagement',
        title: '角色管理',
        meta: {
          title: '角色管理',
          requiredPermissions: ['user_role_manage_menu'],
          showInSidebar: false
        }
      }
      // { path: "5-4", title: "部门管理" },
    ]
  },
  {
    path: '/EnergyAnalysis',
    title: '能耗分析',
    icon: require('@/assets/images/plateform.png'),
    iconActive: require('@/assets/images/plateform-active.png'),
    meta: {
      title: '能耗分析',
      requiredPermissions: ['energy_analysis_menu'],
      showInSidebar: false
    },
    submenu: [
      {
        path: '/Energyoverview/Energyoverview',
        title: '用能概况(待开发)',
        meta: {
          title: '用能概况(待开发)',
          requiredPermissions: ['energy_overview_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/Energyoverview/EnergySavingReport',
        title: '节能报表(待开发)',
        meta: {
          title: '节能报表(待开发)',
          requiredPermissions: ['energy_report_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/Energyoverview/EnergySavingComparison',
        title: '节能对比(待开发)',
        meta: {
          title: '节能对比(待开发)',
          requiredPermissions: ['energy_compare_menu'],
          showInSidebar: false
        }
      }
      // { path: "5-4", title: "部门管理" },
    ]
  }
]
